import { createServiceClient } from 'utils/apiClient'
import { getAuthHeaders } from 'utils/requests'

const client = createServiceClient('')

// Sempre filtre por clientId e/ou processoId — o backend exige ao menos um.
export const listDocumentFolders = async ({ clientId, processoId } = {}) => {
  const query = new URLSearchParams()
  if (clientId) query.set('clientId', clientId)
  if (processoId) query.set('processoId', processoId)
  const { data } = await client.get(`/document-folders?${query.toString()}`, { headers: getAuthHeaders() })
  return data
}

export const createDocumentFolder = async ({ name, clientId, processoId }) => {
  const { data } = await client.post('/document-folders', { name, clientId, processoId }, { headers: getAuthHeaders() })
  return data
}

export const updateDocumentFolder = async (id, name) => {
  const { data } = await client.put(`/document-folders/${id}`, { name }, { headers: getAuthHeaders() })
  return data
}

export const deleteDocumentFolder = async (id) => {
  const { data } = await client.delete(`/document-folders/${id}`, { headers: getAuthHeaders() })
  return data
}
